// issue DOM node
export const getDraggableIssueNode = (id: number) =>
	document.querySelector(`[data-rbd-draggable-id="ISSUE::${id}"]`);

// column DOM node
export const getDraggableColumnNode = (id: number) =>
	document.querySelector(`[data-rbd-draggable-id="COLUMN::${id}"]`);
